import { api } from "./api";

type DashboardSocialOrigin = 'facebook' | 'google' | 'organic' | 'best_plan' | 'tiktok'
  | 'panfleto' | 'nao_atribuido' | 'indication' | 'afiliates' | 'reactivation' | 'outros'

export type DashboardSubOriginV3 =
  | 'direct' | 'flyers' | 'unknown' | 'indication' | 'afiliates' | 'reactivation' | 'pap' | 'condominium' | 'others'

type LeadBoardColumnTagValue = 'pending' | 'waiting_cep' | 'out_area' | 'already_client' | 'finance' | 'negotiation' | 'sold' | 'gave_up' | 'stopped_responding' | 'scheduled' | 'lost_lead'

type DashboardGroupedResume = {
  leads: number;
  leadsCost: number;
  leadsDailyCost: number;
  leadsPercentage: number;
}

type DashboardComputedResume = {
  leads: number;
  leadsPercentage: number;
}

type DashboardFinancialResume = {
  roi: number;
  mrr: number;
}

export type DashboardData = {
  total: {
    dailyInvested: number;
    invested: number;
    leads: number;
    leadsCost: number;
    dailyLeads: number;
    dailyLeadCost: number;
  }
  financial: DashboardFinancialResume
  byArea: {
    insideArea: DashboardGroupedResume
    outsideArea: DashboardGroupedResume
    pendingGrouped: DashboardGroupedResume
  }
  byStatus: {
    [key in LeadBoardColumnTagValue]: DashboardGroupedResume
  }
  byComputed: {
    open: DashboardComputedResume
    lostOpportunity: DashboardComputedResume
    sellsOpportunity: DashboardComputedResume
    sells: {
      total: number;
      soldGrouped: number;
      oldSoldGrouped: number;
      sellCost: number;
      convertionRate: number;
    }
  }
}

type DashboardResponse = {
  [key in DashboardSocialOrigin]: DashboardData
} & {
  total: DashboardData
}

export type DashboardResponseV3 = {
  total: DashboardData
  facebook: DashboardData
  google: DashboardData
  organic: DashboardData & {
    subOrigins: { [K in DashboardSubOriginV3]: DashboardData }
  }
}

export const getDashboardLeadsData = async (
  initDate: Date, endDate: Date, selectedSeller: string
): Promise<DashboardResponse> => {
  const query = new URLSearchParams({
    initDate: initDate.toISOString(),
    endDate: endDate.toISOString(),
    selectedSeller
  })

  const { data } = await api.get<{ data: DashboardResponse }>(
    `v2/dashboard?${query.toString()}`
  )

  return data.data
}

export const getDashboardLeadsDataV3 = async (
  initDate: Date, endDate: Date, selectedSeller: string
): Promise<DashboardResponseV3> => {
  const query = new URLSearchParams({
    initDate: initDate.toISOString(),
    endDate: endDate.toISOString(),
    selectedSeller
  })

  const { data } = await api.get<{ data: DashboardResponseV3 }>(
    `v3/dashboard?${query.toString()}`
  )

  return data.data
}
